export const settingsSelectors = {
  getNoteColors: state => state.settings.present.noteColors,
  getBackgroundColors: state => state.settings.present.backgroundColors,
};
